import React from "react";
const StyledCheckbox = (props) => {
  return (
    <label className="styled-checkbox" onClick={props.onClick}>
      <input
        type="checkbox"
        name={props.name}
        id={props.id}
        checked={props.checked}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      <span
        className={
          (props.disabled
            ? "checkbox checkboxGray"
            : `checkbox ${props.className}`) +
          (props.indeterminate ? " checkboxIndeterminate " : "")
        }
      >
        <span className="check">
          <i
            className={
              props.indeterminate
                ? "icon-omni-cross-grey"
                : "icon-omni-checkbox-true"
            }
          />
        </span>
      </span>
    </label>
  );
};

export default StyledCheckbox;
